import { atom } from 'jotai';
import { atomFamily, atomWithRefresh } from 'jotai/utils';
import { z } from 'zod';
import { guardedClient } from '../features/auth/api/clients';
import {
  listCustomersResponseSchema,
  type ListCustomersResponse,
} from '@minutes-system/backend/src/api/customers/schema';
import fetchAndValidate from '../lib/fetchAndValidate';

// Customersキャッシュの無効化トリガー
// この値をインクリメントすると、atomFamilyで生成された全ページのcustomersQueryAtomが再評価され、APIが再呼び出される
export const customersResetAtom = atom(0);

const customerListParamsSchema = z.object({
  page: z.number().optional(),
  name: z.string(),
  phone: z.string(),
  mobilePhone: z.string(),
});

// パラメータなし（全件取得）またはpage必須（ページネーション付き検索）
type CustomerListParams =
  | { page?: never; name?: never; phone?: never; mobilePhone?: never }
  | { page: number; name?: string; phone?: string; mobilePhone?: string };

export const buildQueryKey = (params: CustomerListParams): string =>
  JSON.stringify({
    page: params.page,
    name: params.name ?? '',
    phone: params.phone ?? '',
    mobilePhone: params.mobilePhone ?? '',
  });

export const customersQueryAtom = atomFamily((key: string) =>
  atomWithRefresh<Promise<ListCustomersResponse>>(get => {
    get(customersResetAtom);
    const params = customerListParamsSchema.parse(JSON.parse(key));

    if (params.page === undefined) {
      return fetchAndValidate(
        guardedClient.customers.$get({ query: {} }) as Promise<Response>,
        listCustomersResponseSchema
      );
    }

    const query: { page: string; name?: string; phone?: string; 'mobile-phone'?: string } = {
      page: String(params.page),
    };
    if (params.name) {
      query.name = params.name;
    }
    if (params.phone) {
      query.phone = params.phone;
    }
    if (params.mobilePhone) {
      query['mobile-phone'] = params.mobilePhone;
    }

    return fetchAndValidate(guardedClient.customers.$get({ query }) as Promise<Response>, listCustomersResponseSchema);
  })
);
